import React from 'react';

/** Altura reservada bajo cada control para hints de conversión (alinea filas de ítems). */
export const LINE_ITEM_HINT_HEIGHT = 'min-h-[14px]';

/**
 * Columna uniforme para filas de ítems: etiqueta + control + espacio inferior fijo.
 */
const LineItemField = ({
  label,
  required = false,
  className = '',
  labelClassName = 'text-gray-700',
  children,
  hint = null,
  hideLabel = false,
  grow = false,
}) => (
  <div className={`flex flex-col min-w-0 ${grow ? 'flex-1' : 'xl:flex-shrink-0'} ${className}`}>
    {hideLabel ? (
      <div className="h-4 mb-1 shrink-0" aria-hidden />
    ) : (
      <label
        className={`block text-xs font-medium mb-1 h-4 leading-4 truncate shrink-0 ${labelClassName}`}
      >
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </label>
    )}
    <div className="min-h-[34px] flex items-center w-full">
      <div className="w-full min-w-0">{children}</div>
    </div>
    <div className={`${LINE_ITEM_HINT_HEIGHT} mt-0.5 text-[10px] leading-[14px] min-w-0 overflow-visible`}>
      {hint || <span className="invisible select-none" aria-hidden>.</span>}
    </div>
  </div>
);

export default LineItemField;
